import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CopilotComponent } from "./copilot.component";
import { SharedModule } from "../shared/shared.module";
import { CopilotSidebarComponent } from "./copilot-sidebar/copilot-sidebar.component";
import { RouterModule } from "@angular/router";
import { CopilotBotComponent } from "./copilot-bot/copilot-bot.component";
import { SliceImageVisualizerComponent } from "./slice-image-visualizer/slice-image-visualizer.component";
import { CopilotImageFlipperComponent } from "./copilot-image-flipper/copilot-image-flipper.component";
import { ShotImageVisualizerComponent } from "./shot-image-visualizer/shot-image-visualizer.component";
import { SaveConversationModalComponent } from "./copilot-bot/save-conversation-modal/save-conversation-modal.component";
import { RagResultVisualizerComponent } from "./rag-result-visualizer/rag-result-visualizer.component";
import { DocumentViewerModalComponent } from "./rag-result-visualizer/document-viewer-modal/document-viewer-modal.component";
import { ChartMessageComponent } from "./chart-message/chart-message.component";
import { NgxEchartsModule } from "ngx-echarts";

@NgModule({
  declarations: [
    CopilotComponent,
    CopilotSidebarComponent,
    CopilotBotComponent,
    SliceImageVisualizerComponent,
    CopilotImageFlipperComponent,
    ShotImageVisualizerComponent,
    SaveConversationModalComponent,
    RagResultVisualizerComponent,
    DocumentViewerModalComponent,
    ChartMessageComponent,
  ],
  imports: [RouterModule, CommonModule, SharedModule, NgxEchartsModule],
  exports: [CopilotComponent, ChartMessageComponent, CopilotBotComponent],
})
export class CopilotModule {}
